import React from 'react';

class Pagination extends React.Component {
  render() {
    const { count, currentPage, perPage, changePage } = this.props;
    const totalPages = Math.ceil(count / perPage);
    let items = [];

    // Сокращение дистанции между страницами
    const minPagesToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(minPagesToShow / 2));
    let endPage = Math.min(startPage + minPagesToShow - 1, totalPages);

    // Добавление элементов пагинации
    items.push(
      <button
        className='arrow'
        key="first"
        onClick={() => changePage(1)}
        disabled={currentPage === 1}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m13.707 4.707-1.414-1.414L3.586 12l8.707 8.707 1.414-1.414L6.414 12l7.293-7.293z"/><path d="m19.707 4.707-1.414-1.414L9.586 12l8.707 8.707 1.414-1.414L12.414 12l7.293-7.293z"/></svg>
      </button>
    );

    items.push(
      <button
        className='arrow'
        key="prev"
        onClick={() => changePage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z"/></svg>
      </button>
    );

    if (startPage > 1) {
      items.push(<span key="ellipsis-start">...</span>);
    }

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <button
          key={number}
          className={number === currentPage ? 'active' : ''}
          onClick={() => changePage(number)}
            >
          {number}
        </button>
      );
    }

    if (endPage < totalPages) {
      items.push(<span key="ellipsis-end">...</span>);
    }

    items.push(
      <button
        className='arrow'
        key="next"
        onClick={() => changePage(currentPage + 1)}
        disabled={currentPage === totalPages || totalPages === 0}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg>
      </button>
    );

    items.push(
      <button
        className='arrow'
        key="last"
        onClick={() => changePage(totalPages)}
        disabled={currentPage === totalPages || totalPages === 0}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m11.707 3.293-1.414 1.414L17.586 12l-7.293 7.293 1.414 1.414L20.414 12l-8.707-8.707z"/><path d="M5.707 3.293 4.293 4.707 11.586 12l-7.293 7.293 1.414 1.414L14.414 12 5.707 3.293z"/></svg>
      </button>
    );

    return <div className="pagination">{items}</div>;
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./js/sport-betting/components/Pagination.jsx